import type { Module } from "@webmotors/ioc";
import { ChatService } from "./chat.service";
import { UserModule } from "../user";
import { WebSocketModule } from "@packages/common";

export const ChatModule: Module = {
  name: "ChatModule",
  modules: [WebSocketModule, UserModule],
  providers: [ChatService],
};
